import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cn from 'classnames';
import Header from '@components/Fireboard/components/Header/index';
import modEnums from '@constants/enums/modEnums';
import { APP_CONFIG } from '@constants';
import style from './FireboardLayout.module.scss';
import SideDrawer from '@components/Fireboard/components/SideDrawer/index';
import HamburgerMenu from '../../components/Fireboard/components/HamburgerMenu/index';
import { setCurrentView, setCurrentMode } from '@reducers/oauth';
import { getChecksList, parseCheck, getDueTime } from './common';
import { getObjectValue, replaceAll } from '@utility/utills';
import PropTypes from 'prop-types';
import {
  updateOrderStatus,
  orderPickedUp,
  newUpdateOrderStatus,
  newOrderPickedUp,
  syncCheck,
  getCustomSmsTemplates,
  printCheck,
  fireboardSendSms,
  getPrintOrderTicket,
  tableReceiptPrint,
  emailReceipt,
  getMemberDetails,
  smsReceipt,
  getFutureOrdersSummary,
  getFutureOrderDetail,
  acknowledgeNotification,
} from '../../reducers/fireboard';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { receiptPrint, receiptEmail, receiptSms } from '@reducers/payment';
import {
  getChecksBasedOnFilters,
  getChecksBasedOnPaidStatus,
  getChecksBasedOnEmployee,
  getChecksBasedOnLocation,
  convertedDate,
} from '../../utility/fireboardUtil';
import { repostPayment } from '@reducers/storeChecks';
import { getPopupConfig } from '@components/common/Popup/index';
import constant from '@components/common/globalization';
import { setErrorOrderFlag } from '../../reducers/fireboard/errorOrder';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const FireboardLayout = props => {
  const {
    tableData,
    currentView,
    setCurrentView,
    currentMode,
    setCurrentMode,
    notificationTableData,
    venueNotificationTableData,
    errorOrderFlag,
    setErrorOrderFlag,
    venueStores,
  } = props;
  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );
  const deviceInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('deviceInfo'), false)
  );
  const countryCode = getObjectValue(
    () => JSON.parse(window.sessionStorage.getItem('auth')).countryCode,
    1
  );

  const [filteredCheckListItem, setFilteredCheckListItem] = useState([]);
  const [selectedCheck, setSelectedCheck] = useState(null);
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
  const [filtersState, setFiltersState] = useState({ paidAndUnpaid: false });
  const [selectedBtn, setSelectedBtn] = useState();
  const [popup, setPopup] = useState(null);
  const [isFlip, setIsFlip] = useState(false);
  const [orderType, setOrderType] = useState([]);
  const orderStatusType = filtersState['Status'] || [];
  const employeeType = filtersState['Employee'] || [];
  const locationType = filtersState['Location'] || [];
  const [activeCheckFilter, setActiveCheckFilter] = useState('sourceType');
  const filteredChecksRef = useRef([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedRightSectionType, setExpandedRightSectionType] = useState(
    constant.EXPANDE_CHECK_DETAILS
  );
  const [customSmsList, setCustomSmsList] = useState();
  const [traceClick, setTraceClick] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [actionClicked, setActionClicked] = useState();
  const checkFilters = {
    orderType: orderType,
    activeCheckFilter: activeCheckFilter,
    checkSourceTypes: [],
    checkOrderTypes: [],
    checkRevenueTypes: [],
    checkLocationTypes: [],
  };
  const [receiptStatus, setReceiptStatus] = useState({});
  const [futureOrdersSummary, setFutureOrdersSummary] = useState();
  const [selectedFutureDate, setSelectedFutureDate] = useState([]);
  const [searchFieldValue, setSearchFieldValue] = useState('');
  const [isfutureOrderScreen, setIsfutureOrderScreen] = useState(false);
  const [sortedCheckList, setSortedCheckList] = useState([]);

  let checks = new Map();
  const bulkTextToPayChecks = useRef([]);
  const location = useLocation();

  // refetching the table checks for filters and actions
  useEffect(() => {
    if (!futureOrdersSummary && currentMode !== 'FUTURE_ORDERS') {
      setChecks(tableData);
    }
  }, [tableData, filtersState, searchFieldValue]);

  // rerender the future orders checks if any action is clicked
  useEffect(() => {
    if (futureOrdersSummary) {
      getFutureOrdersList();
    }
  }, [actionClicked]);

  useEffect(() => {
    setSelectedCheck(null);
  }, [filtersState]);

  useEffect(() => {
    const CheckFilterType = deviceInfo?.deviceGroup?.fireBoardCheckFilterType;
    if (CheckFilterType === 0 || deviceInfo?.deviceGroup === null) {
      setActiveCheckFilter('sourceType');
    } else if (CheckFilterType === 1) {
      setActiveCheckFilter('orderType');
    } else if (CheckFilterType === 2) {
      setActiveCheckFilter('revenueCenter');
    }
  }, [filtersState]);

  const setChecks = check => {
    const allChecks = Object.values(check);
    let checksMap = new Map();

    allChecks &&
      allChecks?.forEach(chk => {
        const existingCheck = checks[chk.id];
        let updatedCheck = chk;
        if (existingCheck) {
          updatedCheck = {
            ...chk,
            selectedForBatchPreauth:
              existingCheck?.selectedForBatchPreauth || false,
          };
        }
        checksMap.set(chk.id, parseCheck(updatedCheck));
      });
    checks = checksMap;
    toggleSelection();
  };

  const filterByOrderTypes = () => {
    let allCheckList = [];
    if (
      orderType === null ||
      (Array.isArray(orderType) && orderType.length === 0) ||
      (Array.isArray(orderType) &&
        orderType.length === 1 &&
        orderType[0].value === 'All')
    ) {
      allCheckList = getChecksList(checks, 'All', storeInfo, activeCheckFilter);
    } else {
      orderType?.forEach(eachType => {
        const checkArr = getChecksList(
          checks,
          eachType,
          storeInfo,
          activeCheckFilter
        );
        if (Array.isArray(checkArr)) {
          allCheckList = [...allCheckList, ...checkArr];
        }
      });
    }
    const uniqueChecks = Array.from(
      new Map(allCheckList.map(item => [item.id, item])).values()
    );
    return uniqueChecks;
  };

  const filterByOrderStatus = checkList => {
    let filteredChecksList = [];
    //no status filter is selected
    if (
      orderStatusType === null ||
      (Array.isArray(orderStatusType) && orderStatusType.length === 0)
    ) {
      filteredChecksList = checkList;
    } else {
      const isWalkUpIncluded = orderType.some(op => op.value === 'Walk up');
      const isCurbsideIncluded = orderType.some(op => op.value === 'Curbside');
      let checksArray = [];
      orderStatusType &&
        orderStatusType?.length > 0 &&
        orderStatusType.forEach(eachStatus => {
          const checks = getChecksBasedOnFilters(
            checkList,
            eachStatus.value,
            isWalkUpIncluded,
            isCurbsideIncluded
          );

          if (Array.isArray(checks)) {
            checksArray = [...checksArray, ...checks];
          }
        });
      // remove duplicate checks
      filteredChecksList = Array.from(
        new Map(checksArray.map(item => [item.id, item])).values()
      );
    }
    return filteredChecksList;
  };

  const toggleSelection = () => {
    const checkList = filterByOrderTypes();
    let filteredChecksList = filterByOrderStatus(checkList);
    setFilteredCheckListItem(filteredChecksList);
    sessionStorage.setItem('chequeCount', checkList?.length);
    const showPaid = filtersState?.paidAndUnpaid ?? true;
    filteredChecksList = getChecksBasedOnPaidStatus(
      filteredChecksList,
      showPaid
    );
    if (employeeType?.length > 0) {
      filteredChecksList = getChecksBasedOnEmployee(
        filteredChecksList,
        employeeType
      );
    }
    if (locationType?.length > 0) {
      filteredChecksList = getChecksBasedOnLocation(
        filteredChecksList,
        locationType
      );
    }
    // serach action on fiterlist
    if (searchFieldValue.trim() !== '') {
      const lowerSearch = searchFieldValue.toLowerCase().trim();
      filteredChecksList = filteredChecksList.filter(
        check =>
          check.phoneNumber?.toLowerCase().includes(lowerSearch) ||
          check.checkNumber?.toLowerCase().includes(lowerSearch) ||
          check.checkInNote?.toLowerCase().includes(lowerSearch) ||
          check.stationName?.toLowerCase().includes(lowerSearch)
      );
    }
    filteredChecksRef.current = filteredChecksList;
    setFilteredCheckListItem(filteredChecksList);
  };

  const onClickHamburger = data => {
    setIsHamburgerOpen(data);
  };

  const onChangeView = mode => {
    setIsHamburgerOpen(false);
    setSearchFieldValue('');
    setSelectedBtn('');
    setCurrentView(mode);
    setFiltersState({ paidAndUnpaid: false });
    if (modEnums.List_View === mode || modEnums.Tile_View === mode) {
      setOrderType([]);
      props.navigate(`${APP_CONFIG.BASE_URL}/fireboard`);
    } else if (modEnums.Cubby_Manager === mode) {
      props.navigate(`${APP_CONFIG.BASE_URL}/fireboard/cubbyManager`);
    } else if (modEnums.Order_Status_Manager === mode) {
      props.navigate(`${APP_CONFIG.BASE_URL}/fireboard/orderStatusManger`);
    }
  };

  const onChangeMode = mode => {
    setIsHamburgerOpen(false);
    setCurrentMode(mode);
    setSelectedBtn('');
    setFiltersState({ paidAndUnpaid: false });
    setSearchFieldValue('');
    setOrderType([]);
  };

  const handleFilterChange = (key, selected) => {
    setSelectedBtn('');
    setFiltersState(prev => ({ ...prev, [key]: selected }));
    if (key === 'Channel' || key === 'Order Type' || key === 'Revenue Center') {
      setOrderType(selected);
    }
  };

  const getPopup = (type, heading, message) => {
    const popup = type === 'spinner' ? getPopupConfig('spinner') : null;
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    setPopup(popup);
  };

  const handleNewOrderUpdate = (payload, type) => {
    getPopup('spinner', null, null);
    props
      .newUpdateOrderStatus(payload, type)
      .then(() => {
        setPopup(null);
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_ORDER_STATUS,
        });
        setIsFlip(false);
        setActionClicked(type);
        if ((type === 'canceled' || type === 'complete') && isExpanded) {
          setIsExpanded(false);
        }
      })
      .catch(error => {
        setPopup(null);
        setIsFlip(false);
        props.setErrorPopUp({ res: error.message });
      });
  };

  const updateOrderStatus = (item, type) => {
    const { id: storeId } = storeInfo || {};
    const payload = {
      storeId,
      deviceId: deviceInfo?.deviceId,
      checkHeaderId: item?.id,
    };
    getPopup('spinner', null, null);
    switch (type) {
      case 'inProgress':
      case 'complete':
      case 'pending':
        handleNewOrderUpdate(payload, type);
        break;
      case 'canceled': {
        const popup = getPopupConfig('success');
        popup.heading = FLABEL().ACTION_ORDER_CANCELLATION;
        popup.message = FLABEL().ACTION_CANCELLATION_MESSAGE;
        popup.buttons = [
          {
            btnType: 'cancel',
            text: FLABEL().ACTION_NO,
            onClick: () => {
              setPopup(null);
            },
          },
          {
            btnType: 'submit',
            text: FLABEL().ACTION_YES,
            onClick: () => handleNewOrderUpdate(payload, type),
          },
        ];
        setPopup(popup);
        break;
      }
      case 'pickedUp':
      case 'notPickedUp':
        props
          .newOrderPickedUp(payload, type === 'notPickedUp' ? 'pending' : type)
          .then(response => {
            setPopup(null);
            setIsFlip(false);
            props.setNotification({
              type: 'success',
              message: FLABEL().TOAST_ORDER_STATUS,
            });
          })
          .catch(error => {
            setPopup(null);
            setIsFlip(false);
            props.setErrorPopUp({
              res: error.message,
            });
          });
        break;
      case 'syncCheck': {
        props
          .syncCheck(item.checkHeaderId)
          .then(response => {
            setPopup(null);
            const checkData = parseCheck(response);
            const checksMap = new Map();

            Object.values(tableData).forEach(chk => {
              checksMap.set(chk.id, parseCheck(chk));
            });

            checksMap.set(checkData.id, checkData);
            checks = checksMap;
            setSelectedCheck(checkData.id);
            !futureOrdersSummary && toggleSelection();
            setIsFlip(false);
            props.setNotification({
              type: 'success',
              message: FLABEL().TOAST_SUCCESS,
            });
          })
          .catch(error => {
            setPopup(null);
            setIsFlip(false);
            props.setErrorPopUp({
              res: error.message,
            });
          });
        break;
      }
      default:
        break;
    }
  };

  const getCustomSmsTemplate = () => {
    props
      .getCustomSmsTemplates(storeInfo?.id)
      .then(response => {
        setCustomSmsList(response);
      })
      .catch(error => {
        console.log({ error });
      });
  };

  const handleExpandedRightSection = type => {
    setIsExpanded(true);
    switch (type) {
      case 'print':
        setExpandedRightSectionType(constant.IS_PRINT_POPUP);
        break;
      case 'notifyGuest':
        getCustomSmsTemplate();
        setExpandedRightSectionType(constant.NOTIFY_GUEST);
        break;
      case 'close':
        setIsFlip(false);
        setIsExpanded(false);
        setExpandedRightSectionType(constant.EXPANDE_CHECK_DETAILS);
        setReceiptStatus({});
        break;
      case 'receipt':
        setExpandedRightSectionType(constant.RECEIPT_BTN);
        break;
      case 'repostPayment':
        setExpandedRightSectionType(constant.REPOST_PAYMENT);
        break;
      default:
        setExpandedRightSectionType(constant.EXPANDE_CHECK_DETAILS);
        break;
    }
  };

  const getPrintStrategy = () => ({
    [FLABEL().PRINT_INDIVIDUAL_ITEM_LABELS]: {
      API: props.printCheck,
      getPayload: filteredCheck => {
        return {
          storeId: filteredCheck?.storeId,
          deviceId: deviceInfo?.deviceId,
          checkHeaderId: filteredCheck?.checkHeaderId,
          checkItemIds: filteredCheck?.items?.map(i => i.checkItemId),
        };
      },
    },
    [FLABEL().PRINT_ORDER_ITEMS]: {
      API: props.printCheck,
      getPayload: filteredCheck => {
        return {
          storeId: filteredCheck?.storeId,
          deviceId: deviceInfo?.deviceId,
          checkHeaderId: filteredCheck?.checkHeaderId,
          includeItems: true,
        };
      },
    },
    [FLABEL().PRINT_FULL_ORDER_LABEL]: {
      API: props.printCheck,
      getPayload: filteredCheck => {
        return {
          storeId: filteredCheck?.storeId,
          deviceId: deviceInfo?.deviceId,
          checkHeaderId: filteredCheck?.checkHeaderId,
          includeItems: false,
        };
      },
    },
    [FLABEL().PRINT_KITCHEN_TICKET]: {
      API: props.getPrintOrderTicket,
      getPayload: filteredCheck => {
        return {
          storeId: filteredCheck?.storeId,
          deviceId: deviceInfo?.deviceId,
          checkHeaderId: filteredCheck?.checkHeaderId,
        };
      },
    },
    [FLABEL().PRINT_GUEST_RECEIPT]: {
      API: props.tableReceiptPrint,
      getPayload: filteredCheck => {
        return {
          storeId: filteredCheck?.storeId,
          deviceId: deviceInfo?.deviceId,
          employeeId: 0,
          seatIds: [],
          checkHeaderId: filteredCheck?.checkHeaderId,
          employeeCard: null,
        };
      },
    },
  });
  const handlePrint = (printType, filteredCheck) => {
    const strategies = getPrintStrategy();
    const strategy = strategies[printType];
    if (!strategy) {
      props.setErrorPopUp({
        res: `Unknown print type: ${printType}`,
        buttonLabel: FLABEL().PRINT_OK,
      });
      return;
    }
    const payload = strategy['getPayload'](filteredCheck);
    getPopup('spinner', null, null);
    strategy['API'](payload)
      .then(res => {
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_SUCCESS,
        });
        setIsExpanded(false);
        setPopup(null);
        setExpandedRightSectionType(constant.EXPANDE_CHECK_DETAILS);
      })
      .catch(error => {
        setPopup(null);
        props.setErrorPopUp({
          res: error.message,
          buttonLabel: FLABEL().PRINT_OK,
        });
      });
  };

  const handleRepostPayment = (ticket, check) => {
    const data = {
      storeId: storeInfo?.id,
      deviceId: deviceInfo?.deviceId,
      employeeId: Number(check?.employeeId),
      ticketId: ticket?.ticketId,
      checkTicketId: ticket?.id,
      checkHeaderId: check?.id,
    };
    props
      .repostPayment(data)
      .then(() => {
        props.setNotification({
          type: 'success',
          message: `Success`,
        });
        setIsExpanded(false);
        setPopup(null);
        setExpandedRightSectionType(constant.EXPANDE_CHECK_DETAILS);
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
        setPopup(null);
      });
  };

  const getRepostConfirmation = (ticket, check) => {
    const popup = getPopupConfig(FLABEL().REPOST_SUCCESS);
    popup.heading = FLABEL().REPOST_CONFIRMATION;
    popup.message = FLABEL().REPOST_MESSAGE;
    popup.buttons = [
      {
        btnType: 'cancel',
        text: FLABEL().REPOST_NO,
        onClick: () => {
          setPopup(null);
        },
      },
      {
        btnType: 'submit',
        text: FLABEL().REPOST_YES,
        onClick: () => handleRepostPayment(ticket, check),
      },
    ];
    setPopup(popup);
  };

  const onHandleSendSms = (msg, customSmsObj, selectedCheck) => {
    const { tickets, unpaidAmount, guestDetails } = selectedCheck;
    const preauthTicket = tickets?.find(
      ticket =>
        ticket.ticketStatusId === 0 && ticket.preAuth && unpaidAmount > 0
    );

    let payload = {
      latitude: '32',
      longitude: '32',
      deviceId: deviceInfo?.deviceId,
      storeId: storeInfo?.id,
      phoneNumber: selectedCheck?.unFormattedPhoneNumber || null,
      countryCode: guestDetails?.countryCode || countryCode,
      message: msg,
      checkHeaderId: selectedCheck?.checkHeaderId || selectedCheck?.id,
    };
    if (customSmsObj?.type === 'custom') {
      payload = {
        ...payload,
        custom: true,
        templateId: customSmsObj?.id,
      };
    }

    if (preauthTicket) {
      payload['checkTicketId'] = preauthTicket?.id || null;
    }
    props
      .fireboardSendSms(payload)
      .then(resp => {
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_NOTIFY_GUEST,
        });
        setIsExpanded(false);
        setIsFlip(false);
        setExpandedRightSectionType(constant.EXPANDE_CHECK_DETAILS);
      })
      .catch(error => {
        props.setErrorPopUp({
          res: error.message,
          buttonLabel: FLABEL().NOTIFY_OK,
        });
      });
  };

  const markOrderAsPickedUp = item => {
    const { id: storeId } = storeInfo || {};
    const payload = {
      checkHeaderId: item.id,
      storeId,
      counter: false,
    };
    getPopup('spinner', null, null);
    props
      .orderPickedUp(payload)
      .then(response => {
        setPopup(null);
        props.setNotification({
          type: 'success',
          message: `success`,
        });
      })
      .catch(error => {
        props.setErrorPopUp({
          res: error.message,
        });
      });
  };
  const getReceiptPrint = (type, ticketList = []) => {
    const filteredCheck = filteredCheckListItem.filter(
      chk => chk.id === selectedCheck
    )[0];
    const payload = {
      storeId: storeInfo.id,
      checkHeaderId: selectedCheck,
      employeeId: filteredCheck?.employeeId,
      employeeCard: null,
      deviceId: deviceInfo?.deviceId,
    };
    let loadingMsg, request;
    if (type === constant.PRINT) {
      getPopup('spinner', constant.PRINT_DATA, null);
      handlePrintReceipt(ticketList, payload);
    } else if (type === constant.EMAIL) {
      loadingMsg = FLABEL().RECEIPT_EMAIL_SPINNER_MSG;
      request = props.receiptEmail;
    } else if (type === constant.SMS) {
      loadingMsg = FLABEL().RECEIPT_SMS_SPINNER_MSG;
      request = props.receiptSms;
    }
    return { payload, request, loadingMsg };
  };

  const handleReceiptSuccess = ticketId => {
    setPopup(null);
    setReceiptStatus(prev => ({
      ...prev,
      [ticketId]: {
        ticketId,
        status: 'success',
        succeded: true,
        failed: false,
      },
    }));
  };

  const handleReceiptFailure = (ticketId, error) => {
    setPopup(null);
    setReceiptStatus(prev => ({
      ...prev,
      [ticketId]: {
        ticketId,
        status: 'failed',
        succeded: false,
        failed: true,
      },
    }));
    props.setErrorPopUp?.({ res: error?.message });
  };

  const handlePrintReceipt = (ticketList, payload) => {
    const promises = ticketList?.map(ticketId => {
      payload = {
        ...payload,
        receipt: {
          emailAddress: null,
          countryCode: countryCode || null,
          phoneNumber: null,
          ticketId: ticketId,
        },
      };

      return props
        .receiptPrint(payload)
        .then(() => handleReceiptSuccess(ticketId))
        .catch(error => handleReceiptFailure(ticketId, error));
    });

    Promise.all(promises)
      .then(() => {
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_SUCCESS,
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const emailReceiptHandler = email => {
    let { payload, request, loadingMsg } = getReceiptPrint(constant.EMAIL);
    payload = {
      ...payload,
      email: email,
      optIn: false,
      phone: false,
      accountNumber: null,
    };
    getPopup('spinner', loadingMsg, null);

    const updateEmailReceiptStatus = (ticket, status) => {
      setPopup(null);
      setReceiptStatus(prev => ({
        ...prev,
        [ticket]: {
          ticketId: ticket,
          status,
          succeded: status === 'success',
          failed: status === 'failed',
        },
      }));
    };
    const promises = tickets?.map(ticket => {
      payload = {
        ...payload,
        receipt: {
          emailAddress: email || null,
          countryCode: countryCode || null,
          phoneNumber: null,
          optIn: false,
          ticketId: ticket,
        },
      };
      return request(payload)
        .then(() => updateEmailReceiptStatus(ticket, 'success'))
        .catch(() => updateEmailReceiptStatus(ticket, 'failed'));
    });

    Promise.all(promises)
      .then(() => {
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_EMAIL_SUCCESS,
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const smsReceiptHandler = (phoneNumber, countryCode) => {
    const phnNumber = replaceAll(phoneNumber, '-');
    const { payload, request, loadingMsg } = getReceiptPrint(constant.SMS);

    getPopup('spinner', loadingMsg, null);

    const updateReceiptStatus = (ticket, status) => {
      setPopup(null);

      setReceiptStatus(prev => ({
        ...prev,
        [ticket]: {
          ticketId: ticket,
          status,
          succeded: status === 'success',
          failed: status === 'failed',
        },
      }));
    };

    const sendSmsReceipt = ticket => {
      const updatedPayload = {
        ...payload,
        receipt: {
          emailAddress: null,
          countryCode: countryCode || null,
          phoneNumber: phnNumber,
          optIn: false,
          ticketId: ticket,
        },
      };

      return request(updatedPayload)
        .then(() => updateReceiptStatus(ticket, 'success'))
        .catch(() => updateReceiptStatus(ticket, 'failed'));
    };

    const promises = tickets?.map(sendSmsReceipt);

    Promise.all(promises)
      .then(() => {
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_SMS_SUCCESS,
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const handleReceipt = (type, tickets, memberId) => {
    if (tickets) {
      setTickets(tickets);
    }
    switch (type) {
      case constant.PRINT:
        getReceiptPrint(type, tickets);
        break;
      case constant.EMAIL:
        setPopup({ type: constant.EMAIL_RECEIPT });
        break;
      case constant.SMS:
        if (memberId) {
          getPopup('spinner', 'Getting member details.', null);
          props
            .getMemberDetails({ memberId: memberId })
            .then(res => {
              setPopup({ type: constant.SMS_RECEIPT, metaData: res });
            })
            .catch(error => {
              setPopup({ type: constant.SMS_RECEIPT });
              console.error('error in getting member details - ', error);
            });
        } else {
          setPopup({ type: constant.SMS_RECEIPT });
        }
        break;
      default:
        break;
    }
  };
  const closePopup = () => {
    setPopup(null);
  };
  const goToBulkTextToPay = () => {
    const filteredChecks = filteredCheckListItem;
    bulkTextToPayChecks.current = [];
    filteredChecks.forEach(check => {
      const excludedCheck =
        check.orderStatusId !== 5 && check.orderStatusId !== 8;
      if (check?.unpaidAmount > 0 && excludedCheck) {
        bulkTextToPayChecks.current.push(check);
      }
    });
    if (bulkTextToPayChecks.current.length > 0) {
      setPopup({ type: constant.BULK_TEXT_TO_PAY });
    } else {
      props.setErrorPopUp({
        res: FLABEL().BULK_NO_CHECKS,
        buttonLabel: FLABEL().BULK_OK,
      });
    }
  };

  const handleHambugerScreens = value => {
    switch (value) {
      case 'futureOrders':
        props.navigate('/fireboard', { replace: true });
        setIsfutureOrderScreen(true);
        getFutureOrdersList();
        break;
      case 'bulkTextPay':
        goToBulkTextToPay();
        break;
      case 'outOfStock':
        props.navigate('/fireboard/outOfStock', { replace: true });
        break;
      case 'sensor':
        props.navigate('/fireboard/sensors', { replace: true });
        break;
      case 'about':
        props.navigate('/fireboard/about', { replace: true });
        break;
      case 'assignEmployee':
        props.navigate('/fireboard/assign/employee', { replace: true });
        break;
      default:
        break;
    }
  };

  const getFutureOrdersList = () => {
    setCurrentMode('FUTURE_ORDERS');
    const payload = {
      latitude: '32',
      longitude: '32',
      storeId: storeInfo?.id,
    };

    getPopup('spinner', null, null);

    props
      .getFutureOrdersSummary(payload)
      .then(res => {
        setIsHamburgerOpen(false);
        setSelectedFutureDate([]);
        setFilteredCheckListItem([]);
        setIsFlip(false);

        // Fetch future order details for each date
        const checkPromises = res.map(({ businessDate }) => {
          const date = convertedDate(businessDate);
          return fetchChecksForDate(date);
        });

        Promise.all(checkPromises)
          .then(allChecks => {
            const flattenedChecks = allChecks.flat();
            setFilteredCheckListItem(flattenedChecks);
            setFutureOrdersSummary(flattenedChecks);
            sessionStorage.setItem('chequeCount', flattenedChecks?.length);
          })
          .catch(err => {
            props.setErrorPopUp({ res: err.message });
          });
        setPopup(null);
      })
      .catch(err => {
        props.setErrorPopUp({ res: err.message });
      });
  };

  const handleDateChange = dates => {
    setSelectedFutureDate(dates);
    setFilteredCheckListItem([]);

    if (!dates?.length) {
      getFutureOrdersList();
      return;
    }

    const checkPromises = dates.map(dateObj => {
      const date = convertedDate(dateObj.value);
      return fetchChecksForDate(date);
    });

    Promise.all(checkPromises)
      .then(allChecks => {
        const flattened = allChecks.flat();
        setFilteredCheckListItem(flattened);
      })
      .catch(err => {
        props.setErrorPopUp({ res: err.message });
      });
  };

  const fetchChecksForDate = date => {
    const payload = {
      latitude: '32',
      longitude: '32',
      storeId: storeInfo.id,
      businessDate: date,
    };

    return props.getFutureOrderDetail(payload).then(res =>
      res.map(check => {
        const parsedCheck = {
          ...parseCheck(check),
          isNew: check.isNew || false,
        };
        const dueTime = getDueTime(parsedCheck);
        return {
          ...parsedCheck,
          dueTime: new Date(dueTime).getTime(),
          dueTimeDisplay: dueTime,
          businessDate: date,
        };
      })
    );
  };

  const acknowledgeNotification = noti => {
    const payload = {
      deviceId: deviceInfo?.deviceId,
      storeId: storeInfo?.id,
      notificationId: noti?.id,
    };
    getPopup('spinner', null, null);
    props
      .acknowledgeNotification(payload)
      .then(() => {
        setPopup(null);
      })
      .catch(err => {
        setPopup(null);
        props.setErrorPopUp({ res: err.message });
      });
  };

  const notificationGoAndDismiss = noti => {
    setPopup(null);
    setSelectedCheck(noti?.data?.checkHeaderId);
    setExpandedRightSectionType(constant.EXPANDE_CHECK_DETAILS);
    setIsExpanded(true);
    setTraceClick(constant.NOTIFICATIONS);
    acknowledgeNotification(noti);
    props.navigate(`${APP_CONFIG.BASE_URL}/fireboard`);
  };

  const HAMBURGER_PATHS = [
    '/fireboard/outOfStock',
    '/fireboard/sensors',
    '/fireboard/about',
    '/fireboard/assign/employee',
    '/fireboard/cubbyManager',
    '/fireboard/notifications',
  ];

  const isHamburgerScreen = HAMBURGER_PATHS.some(path =>
    location.pathname.startsWith(path)
  );

  const onClickOfNotifications = () => {
    // setPopup({ type: constant.NOTIFICATIONS });
    props.navigate(`${APP_CONFIG.BASE_URL}/fireboard/notifications`);
  };

  const onclickErrorOrders = () => {
    setErrorOrderFlag(false);
    setPopup({ type: constant.ERROR_ORDERS });
  };

  return (
    <div className="p-3" style={{ backgroundColor: 'var(--bg-primary)' }}>
      {!isHamburgerScreen && (
        <Header
          onClickHamburger={onClickHamburger}
          handleFilterChange={handleFilterChange}
          filtersState={filtersState}
          currentMode={currentMode}
          currentView={currentView}
          futureOrdersSummary={futureOrdersSummary}
          isfutureOrderScreen={isfutureOrderScreen}
          setIsfutureOrderScreen={setIsfutureOrderScreen}
          setSelectedFutureDate={setSelectedFutureDate}
          setFutureOrdersSummary={setFutureOrdersSummary}
          selectedFutureDate={selectedFutureDate}
          handleDateChange={handleDateChange}
          handleHambugerScreens={handleHambugerScreens}
          setCurrentView={setCurrentView}
          setCurrentMode={setCurrentMode}
          setIsFlip={setIsFlip}
          notificationTableData={notificationTableData}
          venueNotificationTableData={venueNotificationTableData}
          onClickOfNotifications={onClickOfNotifications}
          setSearchFieldValue={setSearchFieldValue}
          searchFieldValue={searchFieldValue}
          errorOrderFlag={errorOrderFlag}
          onclickErrorOrders={onclickErrorOrders}
          venueStores={venueStores}
          tableData={tableData}
        />
      )}
      <main
        className={cn(
          isHamburgerScreen ? style.mainPopUpConatiner : style.mainContainer
        )}
      >
        <Outlet
          context={{
            currentView,
            setCurrentView,
            selectedCheck,
            setSelectedCheck,
            checks,
            filteredCheckListItem,
            checkFilters,
            updateOrderStatus,
            markOrderAsPickedUp,
            setPopup,
            popup,
            isFlip,
            setIsFlip,
            handleExpandedRightSection,
            expandedRightSectionType,
            setExpandedRightSectionType,
            handlePrint,
            isExpanded,
            setIsExpanded,
            traceClick,
            setTraceClick,
            customSmsList,
            onHandleSendSms,
            handleReceipt,
            emailReceiptHandler,
            smsReceiptHandler,
            receiptStatus,
            countryCode,
            bulkTextToPayChecks,
            closePopup,
            futureOrdersSummary,
            isfutureOrderScreen,
            getPopup,
            setFilteredCheckListItem,
            filterByOrderTypes,
            setFiltersState,
            setSelectedBtn,
            selectedBtn,
            filterByOrderStatus,
            notificationTableData,
            venueNotificationTableData,
            acknowledgeNotification,
            notificationGoAndDismiss,
            filtersState,
            setSearchFieldValue,
            searchFieldValue,
            getRepostConfirmation,
            onClickHamburger,
            setOrderType,
            orderType,
            tableData,
            sortedCheckList,
            setSortedCheckList,
            venueStores,
          }}
        />
      </main>
      {/* <Footer /> */}
      {isHamburgerOpen && (
        <div>
          <SideDrawer
            isOpen={isHamburgerOpen}
            onRequestClose={() => onClickHamburger(false)}
            from="left"
            height="100%"
            top="0"
            customClasses={style.menuContainer}
          >
            <HamburgerMenu
              onClickHamburger={onClickHamburger}
              onChangeView={onChangeView}
              currentView={currentView}
              setCurrentView={setCurrentView}
              setSelectedCheck={setSelectedCheck}
              currentMode={currentMode}
              onChangeMode={onChangeMode}
              isFlip={isFlip}
              setIsFlip={setIsFlip}
              handleHambugerScreens={handleHambugerScreens}
              getFutureOrdersList={getFutureOrdersList}
            />
          </SideDrawer>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({
  storeChecks,
  oauth,
  storeNotifications,
  venue,
  errorOrder,
}) => ({
  tableData: { ...storeChecks.checkListHashTable },
  currentView: oauth.currentView,
  currentMode: oauth.currentMode,
  notificationTableData: storeNotifications.storeNotification,
  venueNotificationTableData: venue.venueNotificationTableData,
  errorOrderFlag: errorOrder.errorOrderFlag,
  venueStores: venue.venueStores,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentView,
      setCurrentMode,
      updateOrderStatus,
      orderPickedUp,
      setNotification,
      setErrorPopUp,
      newUpdateOrderStatus,
      newOrderPickedUp,
      syncCheck,
      getCustomSmsTemplates,
      printCheck,
      fireboardSendSms,
      getPrintOrderTicket,
      tableReceiptPrint,
      emailReceipt,
      getMemberDetails,
      smsReceipt,
      receiptPrint,
      receiptEmail,
      receiptSms,
      getFutureOrdersSummary,
      getFutureOrderDetail,
      acknowledgeNotification,
      repostPayment,
      setErrorOrderFlag,
    },
    dispatch
  );

FireboardLayout.propTypes = {
  tableData: PropTypes.object,
  currentView: PropTypes.string,
  setCurrentView: PropTypes.func.isRequired,
  currentMode: PropTypes.string,
  setCurrentMode: PropTypes.func.isRequired,
  notificationTableData: PropTypes.array,
  navigate: PropTypes.func.isRequired,
  newUpdateOrderStatus: PropTypes.func,
  setNotification: PropTypes.func,
  setErrorPopUp: PropTypes.func,
  newOrderPickedUp: PropTypes.func,
  syncCheck: PropTypes.func,
  getFutureOrdersSummary: PropTypes.func,
  getCustomSmsTemplates: PropTypes.func,
  printCheck: PropTypes.func,
  getPrintOrderTicket: PropTypes.func,
  tableReceiptPrint: PropTypes.func,
  fireboardSendSms: PropTypes.func,
  orderPickedUp: PropTypes.func,
  receiptEmail: PropTypes.func,
  receiptSms: PropTypes.func,
  receiptPrint: PropTypes.func,
  getMemberDetails: PropTypes.func,
  getFutureOrderDetail: PropTypes.func,
  acknowledgeNotification: PropTypes.func,
  repostPayment: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(FireboardLayout);
